module.exports = "mutation DeleteBanners($bannerIds:[ID]!){deleteBanners(bannerIds:$bannerIds){success}}"